import React from 'react'

const EssayEditingAdventure = () => {
    return (
        <>
            <section className="main-overcme-sec" >
        <div className="container" >
          <div className="row" >
            <div className="col-lg-12" >
              <div className="ovr-heading" >
                <h2 >Overcome Your Fear By Availing Our Outstanding Essay Editing
                  Proofreading Services And Enjoy The Adventure And Excitement Of Your Life In Your Comfort
                  Zone.</h2>
                <p >We provide essay editing and proofreading help in hundreds of
                  subject areas including business management, medical sciences, humanities, life sciences,
                  finance and economics, social sciences, computer and information technologies, engineering,
                  mathematics, natural sciences, robotics etc. Our professional editors and proofreaders will:
                </p>
              </div>
            </div>
          </div>
          <div className="row vluesldr" >
            <div className="col-lg-3 col-md-3 col-sm-12" >
              <div className="impr-box1" >
                <i className="fa fa-language"  />
                <p >Improve the grammar of your paper.</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12" >
              <div className="impr-box1" >
                <i className="fas fa-sort-alpha-up-alt" />
                <p >Apply advanced grammatical rules in the paper.</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12" >
              <div className="impr-box1" >
                <i className="fa fa-window-restore"  />
                <p >Give proper structure to your paper.</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12" >
              <div className="impr-box1" >
                <i className="fab fa-ioxhost" />
                <p >Make word choices and remove syntax errors.</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12" >
              <div className="impr-box1 mr-tp" >
                <i className="fab fa-wpforms" />
                <p >Enhance the vocabulary of the paper.</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12" >
              <div className="impr-box1 mr-tp" >
                <i className="fa fa-ban"  />
                <p >Remove plagiarism from the manuscript.</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12" >
              <div className="impr-box1 mr-tp" >
                <i className="fa fa-flag-checkered"  />
                <p >Apply international formatting standards.</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12" >
              <div className="impr-box1 mr-tp" >
                <i className="fab fa-linode" />
                <p >Maintain the paper flow by using appropriate facts.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
        </>
    )
}

export default EssayEditingAdventure
